import { Box, Typography } from '@mui/material';
import { get } from 'lodash';
import React from 'react';
import Roman from 'roman-numerals';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { ALLGEMEINE_HINWEISE_FELDERNAME } from 'src/lib/constants/componentsPath';
import { ANTRAG_TYP, DEMINIMIS_ERFORDERLICHKEIT } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import { checkIfDeminimisHasComment } from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import BereitsBeantragteBeihilfenGlobal, { getFormStrucDeMinimisBeantragteBeihilfen } from './content/BereitsBeantragteBeihilfenGlobal';
import BereitsErhalteneBeihilfenGlobal, { getFormStrucDeMinimisErhalteBeihilfen } from './content/BereitsErhalteneBeihilfenGlobal';
import DateienMinimisGlobal, { getFormStrucDateienMinimis } from './content/DateienMinimisGlobal';
import DeMinimisGlobal, { getFormStrucMinimisPruefAssistenz } from './content/DeMinimisGlobal';
import KombinationAnderenBeihilfen, { getFormStrucKombinationAnderenBeihilfen } from './content/KombinationAnderenBeihilfen';

// import schema
import DeminimisHinweiseSchema from 'src/lib/paths/allgemeinehinweisede45minimis_FULL_Paths.json';
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;
const Deminimis_P = DeminimisHinweiseSchema.attributes;

export const TreeStructureDeMinimisGlobal = (application: any, readOnly: boolean, allgemeineHinweiseDeminimis: any) => {
	let treeNodes: TreeNodeType[] = [];

	const anzahlDeMinimisBlock =
		get(allgemeineHinweiseDeminimis, Deminimis_P.Hinweise.path, []).length > 0 ?
			get(allgemeineHinweiseDeminimis, Deminimis_P.Hinweise.path, []).length
		:	0;

	const antragsTyp = get(application, P.Allgemein_Typ.path, '');
	const deminimisKonfigurationErforderlichkeit = get(
		application,
		P.Foerderprogramm.schema.attributes.Konfiguration_Deminimis_Erklaerung_Erforderlich.path,
		'',
	);
	const showDeMinimisErklaerung = shouldShowDeMinimisErklaerung(antragsTyp, deminimisKonfigurationErforderlichkeit);

	const hasCommentDeminimis = checkIfDeminimisHasComment(readOnly, application);

	if (showDeMinimisErklaerung) {
		treeNodes = [
			{
				label: 'De-minimis-Selbsterklärung',
				content: <DeMinimisGlobal />,
				formStruc: getFormStrucMinimisPruefAssistenz(application),
				hasComment: hasCommentDeminimis,
				children: [
					...get(allgemeineHinweiseDeminimis, Deminimis_P.Hinweise.path, []).map((ele: any, i: number) => ({
						label: `${Roman.toRoman(i + 1)}. ${get(ele, ALLGEMEINE_HINWEISE_FELDERNAME.Titel)}`,
						content: (
							<>
								<Box sx={{ mt: '1rem' }}>
									<Typography variant='h3' component={'h3'}>
										{get(ele, ALLGEMEINE_HINWEISE_FELDERNAME.Untertitel, '')}
									</Typography>
									<MarkdownRenderer markdown={get(ele, ALLGEMEINE_HINWEISE_FELDERNAME.Inhalt, '')} />
								</Box>
							</>
						),
					})),
					{
						label: `${Roman.toRoman(anzahlDeMinimisBlock + 1)}. Bereits erhaltene Beihilfen`,
						content: <BereitsErhalteneBeihilfenGlobal hasComment={hasCommentDeminimis} />,
						formStruc: getFormStrucDeMinimisErhalteBeihilfen(application),
					},
					{
						label: `${Roman.toRoman(anzahlDeMinimisBlock + 2)}. Bereits beantragte Beihilfen`,
						content: <BereitsBeantragteBeihilfenGlobal hasComment={hasCommentDeminimis} />,
						formStruc: getFormStrucDeMinimisBeantragteBeihilfen(application),
					},

					{
						label: `${Roman.toRoman(anzahlDeMinimisBlock + 3)}. Kombination mit anderen Beihilfen`,
						content: <KombinationAnderenBeihilfen hasComment={hasCommentDeminimis} />,
						formStruc: getFormStrucKombinationAnderenBeihilfen(application),
					},

					{
						label: `${Roman.toRoman(anzahlDeMinimisBlock + 4)}. De-minimis-Selbsterklärung`,
						content: <DateienMinimisGlobal hasComment={hasCommentDeminimis} />,
						formStruc: getFormStrucDateienMinimis(),
					},
				],
			},
		];
	}
	return treeNodes;
};

function shouldShowDeMinimisErklaerung(typ: string, erforderlichkeit: string) {
	if (erforderlichkeit === DEMINIMIS_ERFORDERLICHKEIT.NichtErforderlich) return false;
	if (erforderlichkeit === DEMINIMIS_ERFORDERLICHKEIT.InAntragUndSkizze) return true;
	if (typ === ANTRAG_TYP.Skizze) return erforderlichkeit === DEMINIMIS_ERFORDERLICHKEIT.NurInSkizze;
	if (typ === ANTRAG_TYP.Antrag) return erforderlichkeit === DEMINIMIS_ERFORDERLICHKEIT.NurImAntrag;

	return false;
}
